module.exports = __webpack_public_path__ + "img/xuanfa08.164b6293.png";